export enum SearchOptionType {
  COUNTY,
  CITY,
  ZONE,
}
